<template>
  <b-modal :id="modalId" size="lg" hide-footer hide-header centered no-stacking no-close-on-backdrop
        no-enforce-focus lazy :content-class="['model-boarder', modalId === MODAL_NAMES.GATED_FEATURES_MODAL && 'custom-margin']">
    <div class="integrated-card">
      <div class="badge bg-success-100 text-success-800" v-html="content.badge"></div>
      <h2 class="title ff-montserrat text-gray-900" v-html="formatTitle(content.title)"></h2>
      <p class="description text-gray-700">{{ content.description }}</p>
      <ul class="feature-list text-gray-600">
        <li class="d-flex" v-for="(feature, idx) in content.features" :key="idx">
          <img src="/img/check-circle.svg" alt="check" class="icon" />
          {{ feature }}
        </li>
      </ul>
    </div>
    <div class="footer d-flex justify-content-end bg-gray-50">
      <button v-if="shouldShowMaybeLater" class="maybe-btn bg-gray-50 text-ashore-black" @click="closeModal">{{ content.maybeLaterText }}</button>
      <button class="upgrade-btn bg-success-500" @click="navigateToBilling">{{ content.upgradeText }}</button>
    </div>
  </b-modal>
</template>

<script>
import { PREMIUM_FEATURE_CONTENT, ROUTES, MODAL_NAMES } from "../../utils/constants";

const { BILLING } = ROUTES;

export default {
  props: {
    featureKey: {
      type: String,
      required: true
    },
    modalId: {
      type: String,
      default: MODAL_NAMES.GATED_FEATURES_MODAL
    },
    shouldShowMaybeLater: {
      type: Boolean,
      default: true,
    }
  },
  data(){
    return {
      content: {},
      MODAL_NAMES
    }
  },
  mounted(){
    this.modalContent();
  },
  watch: {
    featureKey: {
      handler(newVal) {
        this.modalContent();
      },
      immediate: true
    }
  },
  methods: {
    modalContent() {
      this.content = PREMIUM_FEATURE_CONTENT[this.featureKey] || {};
    },
    formatTitle(title) {
      if (!title) return '';
      return title.replace(/\{([^}]+)\}/g, '<span class="text-success-500">$1</span>');
    },
    navigateToBilling() {
      this.$router.push(BILLING);
      this.closeModal();
    },
    closeModal() {
      this.$bvModal.hide(this.modalId);
    },
  }
};
</script>

<style scoped>
::v-deep .model-boarder .modal-body {
  padding: 0px !important;
  border-radius: 8px;
}

.integration-card {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 2px 24px rgba(0, 0, 0, 0.08);
  max-width: 780px;
  margin: auto;
  font-family: 'Open Sans', sans-serif;
  color: #374151;
}

.integrated-card {
  padding: 24px;
  margin: 0px 0px 24px 0px;
}

.badge {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 10px;
  display: inline-block;
  margin-bottom: 16px;
  font-weight: 400;
  line-height: 16px;
}

.title {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 16px;
  line-height: 40px;
}

.description {
  font-size: 18px;
  margin-bottom: 16px;
  font-weight: 400;
  color: #374151;
  line-height: 24px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin-bottom: 24px;
}

.feature-list li {
  align-items: center;
  font-size: 18px;
  margin-bottom: 12px;
  font-weight: 400;
  line-height: 24px;
}

.icon {
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.footer {
  padding: 12px 24px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  overflow: hidden;
}

.upgrade-btn {
  color: #F9F9F9;
  padding: 9px 17px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}

.upgrade-btn:hover {
  background-color: #017a4a;
}

.maybe-btn {
  padding: 10px 24px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
  margin-left: 10px;
  border: none
}

@media screen and (max-width: 640px) {
  ::v-deep .custom-margin {
    margin-top: 50%;
    margin-left: 20px;
    margin-right: 20px;
  }
}

</style>
